import { render, staticRenderFns } from "./EventsLogTab.vue?vue&type=template&id=71029e10&"
import script from "./EventsLogTab.vue?vue&type=script&lang=js&"
export * from "./EventsLogTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports